import axios from "axios";

const apiUrl = process.env.REACT_APP_BACKEND_URL || "https://portfoliobackend-3sr0wqpki-isurus-projects-40d8fc72.vercel.app/";

const api = axios.create({
  baseURL: apiUrl,
});

export const setAuthorizationToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export default api;

export const domainName = apiUrl;
